/* Gifting hub (/pages/gifting) — occasion links, box filter and add to cart.
   Markup it binds to, all rendered by sections/gifting-hub.liquid:
     .occ4 a[data-f]        occasion cards that also set the box filter
     .moods button[data-m]  filter chips
     #gh-grid .card[data-mood] ready gift boxes
     .card .add             adds the variant it opens on
     #gh-toast / #gh-tmsg   this page's toast (the theme's own toast is separate)
   Prices and images are server-rendered, so nothing here is product-specific. */
(function () {
  "use strict";

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = document.getElementById("gh-toast");
    var tm = document.getElementById("gh-tmsg");
    if (!t) return;
    if (tm) tm.textContent = msg;
    t.style.display = "flex";
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.style.display = "none"; }, 3500);
  }

  function syncCount(count) {
    $$("[data-mm-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return Promise.resolve();
    return fetch(location.pathname + "?sections=cart-drawer", {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections["cart-drawer"]) {
          drawer.renderContents({ id: "cart-drawer", sections: data.sections });
        } else {
          drawer.open();
        }
      })
      .catch(function () { drawer.open(); });
  }

  function addVariant(id, name) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _source: "gifting" } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("add");
      return fetch("/cart.js").then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      syncCount(cart.item_count);
      return name;
    });
  }

  /* ------------------ filter chips ------------------ */

  var moods = document.querySelector(".moods");
  var grid = document.getElementById("gh-grid");

  function applyFilter(m) {
    if (!moods || !grid) return;
    $$("button[data-m]", moods).forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.dataset.m === m));
    });
    var shown = 0;
    $$(".card[data-mood]", grid).forEach(function (card) {
      var hit = m === "all" || card.dataset.mood === m;
      card.hidden = !hit;
      if (hit) shown++;
    });
  }

  if (moods && grid) {
    moods.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-m]");
      if (b) applyFilter(b.dataset.m);
    });
  }

  /* ------------------ occasion cards that set the filter ------------------ */

  $$(".occ4 a[data-f]").forEach(function (a) {
    a.addEventListener("click", function () {
      applyFilter(a.dataset.f);
    });
  });

  /* ------------------ add to cart ------------------ */

  document.addEventListener("click", function (e) {
    var b = e.target.closest(".add");
    if (!b || b.disabled) return;
    var vid = b.dataset.variantId;
    if (!vid) return;
    var name = b.dataset.name || "Gift box";
    var st = b.parentNode ? b.parentNode.querySelector(".status") : null;

    b.setAttribute("aria-busy", "true");
    b.disabled = true;
    addVariant(vid, name)
      .then(function () {
        if (st) { st.className = "status"; st.textContent = "Added to cart"; }
        toast(name + " added");
        openCartDrawer();
      })
      .catch(function () {
        if (st) { st.className = "status err"; st.textContent = "Couldn’t add. Try again or order on WhatsApp."; }
      })
      .finally(function () {
        b.removeAttribute("aria-busy");
        b.disabled = false;
      });
  });
})();
